export default "/result.69549346-85a9ec.jpg";